<template>
  <div class="content">
    <div class="condition">
      <div class="search_wrap">
        <!-- <el-radio-group class="whd-radio pl20" v-model="state" @change="radioChange" size="small"> 
          <el-radio-button label="1">剩余佣金</el-radio-button>
          <el-radio-button label="2">提现中佣金</el-radio-button>
          <el-radio-button label="3">未入账佣金</el-radio-button>
        </el-radio-group>          -->
        <el-form :inline="true" :model="postData" class="form-inline">
          <el-form-item>
            <span class="choosedep">{{depart_name}}</span>
            <el-button @click="choosedep" size="small">选择部门</el-button>
          </el-form-item>
          <el-form-item>
            <el-input v-model="postData.name" placeholder="输入姓名查询" size="small"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="small" @click="searchFn()"></el-button>
            <el-button class="initList" @click="initList" size="small">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="table_wrap">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="头像" width="180">
          <template slot-scope="scope">
            <div class="td_img">
              <img :src="scope.row.pic" alt width="60" height="60"/>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="业务员" width="180"></el-table-column>
        <el-table-column prop="phone" label="手机"></el-table-column>
        <el-table-column prop="department" label="部门"></el-table-column>
        <el-table-column prop="commission" label="可提现佣金"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="checkemployee(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pag_wrap" v-if="page.total!==0">
        <el-pagination
            background
            @current-change="pageIndexChange"
            :page-size="page.pagesize"
            :current-page="page.pageindex"
            layout="prev, pager, next"
            :total="page.total"></el-pagination> 
      </div>
    </div>
    <chooseDepDialog
            :visible.sync="choosedepdialog"
            v-if="choosedepdialog"
            @choosedepsucess="choosedepsucess"
    ></chooseDepDialog>
    <addcheckemployee
            :visible.sync="addcheckemployeedialog"
            v-if="addcheckemployeedialog"
            :employeeId="employeeId"
    ></addcheckemployee>
  </div>
</template>
<script>
  import api from "@/api.js";
  import chooseDepDialog from "@/components/dialog/chooseDepDialog.vue";
  import addcheckemployee from "@/components/dialog/addcheckemployee.vue";
  import {pagination} from "@/util/util.js";


  export default {
    name: "employeeCommission",
    components: {
      chooseDepDialog,
      addcheckemployee
    },
    data() {
      return {
        // formdata: {
        //   user: ""
        // },
        addcheckemployeedialog:false,
        radio1: "",
        tableData: [],
        depart_name:'',
        choosedepdialog: false,
        postData:{
          name: '',
          depart_id:''
        },
        page: {
          pageindex: pagination.pageIndex,
          pagesize: pagination.pageSize,
          total: pagination.total
        },
        total: 0,
        employeeId:'',
        state: 1
      };
    },
    created() {
      this.InitFn()
    },
    methods: {
      InitFn() {
        this.postData.page = this.page.pageindex
        this.axios
            .post(api.financial_employee, this.postData)
            .then(response => {
              if (response.data.code == 0) {
                this.tableData = response.data.list
                this.page.total = response.data.all_page
              } else {
              }
            })
            .catch(response => {
            });
      },
      searchFn(){
        if(!this.postData.name&&!this.postData.depart_id){
          this.$message.error('请选择你要搜索的内容');
          return
        }
        this.page.pageindex = 1
        this.InitFn()
      },
      // 选择部门
      choosedep() {
        this.choosedepdialog = true;
      },
      choosedepsucess(val) {
        this.depart_name = val.name;
        this.postData.depart_id = val.id;
      },
      checkemployee(option){
        this.employeeId = option.id
        this.addcheckemployeedialog = true
      },
      initList(){
        this.depart_name = '';
        this.postData.depart_id = '';
        this.postData.name = '';
        this.page.pageindex = 1;
        this.InitFn()
      },
      pageIndexChange(pageindex) {
        this.page.pageindex = pageindex;
        this.InitFn()
      },
      radioChange(option) {
        this.state = option;
      }
    }
  };
</script>
